import { connect } from 'react-redux';
import type { PaleState } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { TravelTimePicker, type TravelTimePickerProps } from './TravelTimePicker';

const mapStateToProps = (state: PaleState): Pick<TravelTimePickerProps, 'travelMonths' | 'duration'> => ({
    travelMonths: state.filters.travelMonths,
    duration: state.filters.duration,
});

const mapDispatchToProps = {
    setIgnoredFilters: actions.setIgnoredFilters,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(TravelTimePicker);
